var _path, _path2, _g, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCanada = function SvgCanada(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M190.909 100c0-50.208-40.701-90.91-90.909-90.91C49.792 9.09 9.09 49.793 9.09 100s40.702 90.909 90.91 90.909 90.909-40.701 90.909-90.909"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "Canada_svg__a",
    width: 182,
    height: 182,
    x: 9,
    y: 9,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M190.909 100c0-50.208-40.701-90.91-90.909-90.91C49.792 9.09 9.09 49.793 9.09 100s40.702 90.909 90.91 90.909 90.909-40.701 90.909-90.909"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#Canada_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M37.89 9.09h128.658v181.82H37.891V9.091Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D52B1E",
    d: "M-26.42 9.09h64.31v181.82h-64.31V9.091Zm192.968 0h64.311v181.82h-64.311V9.091ZM57.138 96.947l-4.972 1.705 23.225 20.419c1.775 5.255-.604 6.783-2.131 9.552l25.213-3.196-.64 25.39 5.256-.177-1.172-25.177 25.285 2.983c-1.563-3.303-2.947-5.043-1.527-10.299l23.224-19.353-4.048-1.457c-3.338-2.591 1.42-12.357 2.131-18.536 0 0-13.53 4.652-14.418 2.201l-3.516-6.57-12.286 13.495c-1.35.355-1.918-.213-2.237-1.35l5.681-28.302-9.02 5.078c-.746.32-1.491 0-1.989-.852l-8.7-17.4-8.949 18.075c-.674.639-1.349.71-1.917.284l-8.594-4.83 5.15 28.125c-.391 1.066-1.386 1.42-2.522.817L71.84 74.148c-1.527 2.486-2.593 6.534-4.617 7.457-2.024.817-8.878-1.74-13.459-2.734 1.563 5.646 6.463 15.02 3.374 18.11v-.035"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#8E8E8E",
    strokeLinejoin: "bevel",
    strokeMiterlimit: 0,
    strokeWidth: 3,
    d: "M190.909 100c0-50.208-40.701-90.91-90.909-90.91C49.792 9.09 9.09 49.793 9.09 100s40.702 90.909 90.91 90.909 90.909-40.701 90.909-90.909Z"
  })));
};
export default SvgCanada;